export default "__VITE_ASSET__BB9JzpTO__"